import { render, staticRenderFns } from "./ActionColumnForm.vue?vue&type=template&id=962981be&scoped=true&"
import script from "./ActionColumnForm.vue?vue&type=script&lang=ts&"
export * from "./ActionColumnForm.vue?vue&type=script&lang=ts&"
import style0 from "./ActionColumnForm.vue?vue&type=style&index=0&id=962981be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962981be",
  null
  
)

export default component.exports